import {
  ORGANIZATION_SUCCESS,
  ORGANIZATION_IS_FETCHING,
  ORGANIZATION_LIST
} from '../types'

const initialState = {
  isFetching: false,
  data: {
    id: 0,
    name: ''
  },
  list: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ORGANIZATION_SUCCESS:
      return {
        ...state,
        data: action.payload
      }

    case ORGANIZATION_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload
      }

    case ORGANIZATION_LIST:
      return {
        ...state,
        list: action.payload
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/organization.js